<script setup lang="ts">
import { ref } from 'vue'

import { useShiftCreateMutation } from '../../../shifts/composables/useShift'
import { useScheduleDuplicateDialog } from '../../composables/useScheduleDuplicateDialog'

import { SiteID } from '../../../sites/models/site'

import { ShiftCreateForm } from '../../../shifts/shiftService'

const { siteId } = defineProps<{
  siteId: SiteID
}>()

const { hide, isShown, shift } = useScheduleDuplicateDialog()

const duplicateCount = ref(1)

const { mutateAsync: createShiftAsync, isPending: isCreatePending } =
  useShiftCreateMutation()
const duplicatePressed = async () => {
  const duplicatingShift = shift.value
  if (!duplicatingShift) {
    return
  }

  const form: ShiftCreateForm = {
    areaId: duplicatingShift.areaId,
    startDate: duplicatingShift.startDate,
    endDate: duplicatingShift.endDate,
    //
    open: duplicatingShift.open,
    approvalRequired: duplicatingShift.approvalRequired,

    note: duplicatingShift.note,

    rateAmount: duplicatingShift.rateAmount,

    skillIds: duplicatingShift.skills?.map((skill) => skill.id),
  }

  try {
    const promises = Array.from({ length: duplicateCount.value }, () =>
      createShiftAsync({
        siteId: siteId,
        form,
      }),
    )

    await Promise.all(promises)

    hide()
  } catch (error) {
    console.error('Error duplicating shifts:', error)
  }
}
</script>

<template>
  <Dialog
    :visible="isShown"
    header="Duplicate Shift"
    dismissable-mask
    modal
    class="w-full max-w-md md:w-1/2"
    @update:visible="hide"
  >
    <div class="m-1 flex flex-col gap-y-4">
      <span>Number of duplicates</span>
      <div class="flex flex-col gap-4">
        <InputNumber v-model="duplicateCount" show-buttons :min="1" :max="10" />
      </div>

      <div class="flex justify-end space-x-2">
        <Button
          label="Cancel"
          :pt:root:class="'w-fit self-end'"
          text
          @click="hide"
        />
        <Button
          label="Duplicate"
          :loading="isCreatePending"
          :pt:root:class="'w-fit self-end'"
          @click="duplicatePressed"
        />
      </div>
    </div>
  </Dialog>
</template>
